export default {
  symbols: ['BTC', 'ETH', 'LTC', 'XLM', 'ADA', 'EOS', 'MIOTA'],
  currency: 'USD',
  prices: {},
  history: {},
  settings: {
    interval: 3,
  },
};
